import { render, staticRenderFns } from "./CustomerReportFields.vue?vue&type=template&id=3552e814"
import script from "./CustomerReportFields.vue?vue&type=script&lang=js"
export * from "./CustomerReportFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports